'use client';

import Image from 'next/image';
import RegistrationModal from '~/app/[locale]/auth/_components/RegistrationModal';
import Flex from '~/components/customComponents/flex/Flex';

/**
 * Register Page
 *
 * Renders the registration form in RegistrationModal over a blurred background.
 */
const RegisterPage = () => {
  return (
    <>
      <Flex className="fixed inset-0 w-full h-full overflow-hidden">
        <Image
          className="w-full h-full object-cover blur-sm scale-101"
          src="/images/register_page_background.webp"
          alt="Registration background"
          fill
          priority
          quality={85}
          style={{ objectFit: 'cover' }}
        />
      </Flex>
      <RegistrationModal />
    </>
  );
};

export default RegisterPage;
